import React, { FC } from 'react'
import { InputLabel, InputLabelProps } from '@mui/material'

export const EvtInputLabel: FC<InputLabelProps> = ({ children, ...props }) => {
    return <InputLabel {...props}>{children}</InputLabel>
}

export default EvtInputLabel
